import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';

const WatchYourMail = ({ priorCarrier }) => {
    return (
        <Timeline
            seperator="SO, WHAT'S NEXT?"
            heading="watch your mail"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon15"
                    name="envelope"
                    datacy="envelope"
                    size="2x"
                />
            }>
            {`We sent your new policy a few days ago. When it arrives, take a few minutes to review
            and verify everything. Your Safeco policy begins on the same date that your ${
                priorCarrier ? priorCarrier : 'previous'
            }
            policy expires.`}
        </Timeline>
    );
};

export default WatchYourMail;



// WEBPACK FOOTER //
// ./src/containers/WatchYourMail/WatchYourMail.jsx